import { SendNotificationsObservable } from "./NotificationContactsProcess"
import useNotificationAction from "./useNotificationAction"

function useNotificationsSend(callback?: (result?: string) => void | Promise<void>) {
  const [processing, sendNotifications] = useNotificationAction<string>({
    actionObservable: SendNotificationsObservable,
    callback,
  })

  return { sendingNotifications: processing, sendNotifications }
}

export default useNotificationsSend
